import type { IconListProps as Props } from './types';
import RichText from '../RichText';
import { cls } from '@/utils/cls';
import style from './IconList.module.scss';
import Image from 'next/image';
export default function IconList({
  extendStyles,
  heading,
  listItems,
  secondaryHeroLoc
}: Props) {
  const _className = cls(style.root, extendStyles);
  const containerAttribs: Record<string, string> = {
    className: secondaryHeroLoc ? style.narrow : ''
  };

  // only add data-grid attribute for the Secondary Hero Placement
  if (secondaryHeroLoc) {
    containerAttribs['data-grid'] = 'true';
  }
  return <section className={_className} data-sentry-component="IconList" data-sentry-source-file="IconList.tsx">
			<div {...containerAttribs}>
				{heading && <RichText text={heading} className={style.heading} />}
				<div className={style.content}>
					{listItems && listItems.map((item, i) => <div key={`icon-list-item${i}`} className={style.tile}>
								<div className={style.wrapper}>
									{item.icon && <Image src={item.icon} role="presentation" alt="" className={style.img} width={100} height={105} />}
								</div>
								{item.text && <RichText text={item.text} className={style.text} />}
							</div>)}
				</div>
			</div>
		</section>;
}